/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Interval_HelpInputs */



/**
* | output |
* | --- |
* | "How frequently snapshot backups will be created" |
*
* @param {Options_Backup_Interval_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_interval_help = /** @type {((inputs?: Options_Backup_Interval_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Interval_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fréquence de création des instantanés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie häufig werden Snapshot-Backups erstellt?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Con quale frequenza verranno creati i backup degli snapshot")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Как часто будут создаваться резервные копии в виде моментальных снимков?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Con qué frecuencia se crearán copias de seguridad de instantáneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照备份的创建频率如何")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スナップショットバックアップが作成される頻度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैपशॉट बैकअप कितनी बार बनाए जाएंगे?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Com que frequência serão criados backups instantâneos?")
	return /** @type {LocalizedString} */ ("How frequently snapshot backups will be created")
});